export const en = {
    'banner-types': 'Examples of ads in Yandex Advertising Network blocks',
    'banner-types-description':
        'The appearance of an ad depends on the settings of each platform. Please note that, in some formats, part of the ad text may be clipped.',
    'desktop-and-mobile': 'Desktop and mobile platforms',
    'more-about-video': 'Learn more about video extensions',
    'no-video-text': 'Video extension not active for this ad. You can add on in the Ad Builder.',
    size: 'Size',
    video: 'Video platforms'
};
